import { render, staticRenderFns } from "./OverviewCountTotalProducts.vue?vue&type=template&id=0cdcef4c&"
import script from "./OverviewCountTotalProducts.vue?vue&type=script&lang=js&"
export * from "./OverviewCountTotalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports